import React from 'react'
import Login from './login/Login';
import {ToastContainer} from 'react-toastify'
import Home from './pages/Home/Home';
import { AuthProvider, useAuth } from './context/authContext';
import Home2 from './pages/home2/Home2';





 function App() {

  const [isLoading, setIsLoading] = React.useState(false)

  const {user}=useAuth()

  


  return (
    < >

    {

          

              <Home2 user={user} />
              
              
    
  }

    <ToastContainer  
      position="top-center"
      autoClose={5000}
      hideProgressBar
      newestOnTop
      closeOnClick
      rtl={false}
      draggable
      pauseOnHover={false}
    
    />
    </>
  );
}

function Main (){

 return(

  <AuthProvider>
    <App/>
  </AuthProvider>
 )

}

export default Main;